import { render } from "./ActorEditor.vue?vue&type=template&id=0bf72d5c"
import script from "./ActorEditor.vue?vue&type=script&lang=js"
export * from "./ActorEditor.vue?vue&type=script&lang=js"
script.render = render

export default script